module.exports = __webpack_public_path__ + "static/img/feiliao.717332fb.png";